<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
 import {webId} from '@/api/ajax';
    export default {
        name: 'bodyMain',
        mounted() {
            const script = document.createElement('script')
            script.src = "https://s95.cnzz.com/z_stat.php?id="+webId()+"&web_id="+webId()
            script.language = 'JavaScript'
            document.body.appendChild(script)
        },
        watch: {
            '$route' () {
                if (window._czc) {
                    let location = window.location
                    let contentUrl = location.pathname + location.hash
                    let refererUrl = '/'
                    window._czc.push(['_trackPageview', contentUrl, refererUrl])
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/App.vue